// Terms of Service acceptance in the app. See docs/terms-acceptance.md.

import type { TermsStatus } from "shared/TermsConstants";
import type { AuthState } from "shared/UtilTypes";

/**
 * Whether the portal must ask the signed-in person to accept the Terms (the backend computes the
 * status): `missing` or `outdated`, or undefined when there's nothing to ask. Staff impersonating
 * an account are never asked; they can't accept for its owner.
 */
export const getRequiredTermsStatus = (
  authState: AuthState | undefined,
): Exclude<TermsStatus, "accepted"> | undefined => {
  if (!authState?.user || authState.impersonating) return undefined;
  const status = authState.termsStatus;
  return status === "missing" || status === "outdated" ? status : undefined;
};
